export function isArrayEmpty<T> (arr: T[]): boolean {
    return !arr || arr.length === 0 || arr.every(item => item === null);
}
